<template>
  <div>
    <nav
      class="main-header navbar navbar-expand navbar-white navbar-light text-xs pt-1 pb-1 bg-sos-green justify-content-between"
    >
      <!-- Left navbar links -->
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" data-widget="pushmenu" href="#" role="button">
            <i class="fas fa-bars"></i>
          </a>
        </li>
        <li class="nav-item">
          <img
            class="img-circle img-size-32 elevation-1"
            src="/img/sos_logos/Logo_sos_contingencias.jpg"
            alt="Gerenciamiento de Flota"
          />
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a href="/" class="nav-link">Home</a>
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <a href="#" class="nav-link">Contact</a>
        </li>
      </ul>
      <!-- Center navbar empresa -->
      <ul class="navbar-nav" v-if="$parent.empresa && !isSosUser">
        <li class="nav-item d-none d-sm-inline-block">
          <img
            :src="`${$parent.uri_docs}${$parent.empresa.logo}`"
            :alt="$parent.empresa.razon_social"
            class="img-circle img-size-64 elevation-2"
            style="margin-top: 8px"
          />
        </li>
        <li class="nav-item d-none d-sm-inline-block">
          <span class="nav-link empresa-nombre">{{
            $parent.empresa.razon_social
          }}</span>
        </li>
      </ul>
      <!-- Right navbar links -->
      <ul class="navbar-nav">
        <!-- Navbar Search -->
        <!-- <li class="nav-item">
          <a
            class="nav-link"
            data-widget="navbar-search"
            href="#"
            role="button"
          >
            <i class="fas fa-search"></i>
          </a>
          <div class="navbar-search-block">
            <form class="form-inline">
              <div class="input-group input-group-sm">
                <input
                  class="form-control form-control-navbar"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <div class="input-group-append">
                  <button class="btn btn-navbar" type="submit">
                    <i class="fas fa-search"></i>
                  </button>
                  <button
                    class="btn btn-navbar"
                    type="button"
                    data-widget="navbar-search"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li> -->
        <!-- Notifications Dropdown Menu -->
        <!-- <li class="nav-item dropdown">
          <a
            class="nav-link"
            data-toggle="dropdown"
            href="#"
          >
            <i class="far fa-bell"></i>
            <span class="badge badge-warning navbar-badge">15</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
            <span class="dropdown-item dropdown-header">15 Notifications</span>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <i class="fas fa-envelope mr-2"></i> 4 new messages
              <span class="float-right text-muted text-sm">3 mins</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <i class="fas fa-users mr-2"></i> 8 friend requests
              <span class="float-right text-muted text-sm">12 hours</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item">
              <i class="fas fa-file mr-2"></i> 3 new reports
              <span class="float-right text-muted text-sm">2 days</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item dropdown-footer"
              >See All Notifications</a
            >
          </div>
        </li> -->
        <li class="nav-item">
          <a class="nav-link" data-widget="fullscreen" href="#" role="button">
            <i class="fas fa-expand-arrows-alt"></i>
          </a>
        </li>
        <li class="nav-item">
          <div class="custom-control custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-control-input"
              id="customSwitch1"
              @change="$parent.darkModeChange(checkDarkMode)"
              v-model="checkDarkMode"
            />
            <label class="custom-control-label" for="customSwitch1">
              <i class="fas fa-adjust"></i>
            </label>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="dropdown" href="#">
            <i class="far fa-user"></i>
            {{ this.$store.state.user.email }}
          </a>
          <div class="dropdown-menu dropdown-menu-xl dropdown-menu-right p-0">
            <div class="card card-widget widget-user-2 m-0">
              <!-- Add the bg color to the header using any of the bg-* classes -->
              <div class="widget-user-header bg-sos-gradient mr-0">
                <!-- /.widget-user-image -->
                <h4 class="text-white">
                  <b>{{ this.$store.state.user.name }}</b>
                </h4>
                <hr style="border: 1px solid white" />
                <h5 class="text-white" style="display: inline">
                  <b>Cargo:</b>
                </h5>
                <h6 class="text-white" style="display: inline">
                  {{ this.$store.state.user.charge }}
                </h6>
                <!--  <h5
                  class="text-white"
                  style="display: inline"
                  v-if="this.$store.state.user.empresas.length > 0"
                >
                  <b>Empresa:</b>
                </h5>
                <h6
                  class="text-white"
                  style="display: inline"
                  v-if="this.$store.state.user.empresas.length > 0"
                >
                  {{ this.$store.state.user.empresas[0].razon_social }}
                </h6> -->
                <br />
                <h5 class="text-white" style="display: inline">
                  <b>Correo:</b>
                </h5>
                <h6 class="text-white" style="display: inline">
                  {{ this.$store.state.user.email }}
                </h6>
              </div>
              <div class="card-footer p-1">
                <ul class="nav flex-column">
                  <!--  <li class="nav-item">
                    <a
                      href="#"
                      class="nav-link"
                      :class="checkDarkMode ? 'dark-mode text-white' : ''"
                    >
                      <router-link to="/PerfilUsuario">
                        <i class="fa fa-user"></i> Perfil
                      </router-link>
                    </a>
                  </li> -->
                  <li class="nav-item">
                    <a
                      href="#"
                      class="nav-link"
                      data-toggle="modal"
                      data-target="#modal-actualizar-clave"
                      :class="checkDarkMode ? 'dark-mode text-white' : ''"
                    >
                      <i class="fa fa-lock"></i> Cambiar clave
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      href="#"
                      @click="logout"
                      class="nav-link"
                      :class="checkDarkMode ? 'dark-mode text-white' : ''"
                    >
                      <i class="fa fa-window-close"></i> Salir
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
        <!-- <li class="nav-item">
          <a
            class="nav-link" :class="checkDarkMode ? 'dark-mode text-white' : ''"
            data-widget="control-sidebar"
            data-controlsidebar-slide="true"
            href="#"
            role="button"
          >
            <i class="fas fa-th-large"></i>
          </a>
        </li> -->
      </ul>
    </nav>
    <UpdatePassword></UpdatePassword>
  </div>
</template>

<script>
import UpdatePassword from "../UpdatePassword";

export default {
  name: "NavBarTop",

  components: {
    UpdatePassword,
  },

  data() {
    return {
      checkDarkMode: false,
    };
  },

  computed: {
    isSosUser() {
      const user = this.$store.state.user;
      return user && user.id === 78;
    },
  },

  methods: {
    async logout() {
      await this.$store.dispatch("logout");
      // La redirección ya se maneja en el store, no duplicar aquí
    },
  },
};
</script>
<style>
.empresa-nombre {
  font-size: 0.8rem;
  font-weight: 600;
  color: #00529c;
  white-space: nowrap;
}
</style>
